/**
 * useClearSelectionOnFilterChange — Iter 265.3
 *
 * If the current user opted into "clear selection when filters change", this
 * hook watches the supplied filter deps and calls `deselectAll` whenever any
 * of them changes (after the first mount).
 *
 * Default off — some dispatchers rely on keeping their bulk selection alive
 * while they narrow the view.
 */
import { useEffect, useRef } from 'react';

export default function useClearSelectionOnFilterChange({
  enabled = false,
  deselectAll,
  deps = [],
}) {
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (enabled && typeof deselectAll === 'function') {
      try { deselectAll(); } catch (_) { /* ignore */ }
    }
  }, deps);
}
